"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowDown = _interopRequireDefault(require("./ArrowDown"));

var _styles = require("./styles");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var VerticalLineExtended = function VerticalLineExtended(_ref) {
  var columnRangeType = _ref.columnRangeType,
      startDatetime = _ref.startDatetime,
      columnSections = _ref.columnSections,
      columnQuantity = _ref.columnQuantity,
      actions = _ref.actions,
      onDivisionSummary = _ref.onDivisionSummary;
  // const resultDate = getDateTime(startDatetime, columnRangeType, columnQuantity)
  var today = Date.parse(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
  var now = Date.parse(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), new Date().getHours()));
  var intervals = getIntervals(startDatetime, columnRangeType, columnQuantity);
  return intervals.map(function (interval, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: ''.concat(100 / columnQuantity, '%')
      },
      key: "interval-".concat(index)
    }, getHourDateCaption(columnRangeType, index, intervals), /*#__PURE__*/_react["default"].createElement(_styles.ColumnBegin, columnRangeType, getDateCaption(interval.begin, columnRangeType)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "division d-flex column ",
      style: {
        width: '100%',
        borderLeft: index === 0 ? 'solid 1px white' : ''
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex align-items-end",
      style: {
        width: '100%',
        marginTop: '10px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_ArrowDown["default"], {
      key: "arrow-".concat(index),
      current: columnRangeType === 'DAY' ? today === Date.parse(interval.begin) : now === Date.parse(interval.begin),
      interval: interval,
      className: "hoverSection",
      onDivisionSummary: onDivisionSummary,
      columnSections: columnSections
    }))));
  });
};

VerticalLineExtended.propTypes = {
  onDivisionSummary: _propTypes["default"].func
};
var _default = VerticalLineExtended;
exports["default"] = _default;
var WeekDaysShort = {
  0: 'DOM',
  1: 'LUN',
  2: 'MAR',
  3: 'MIE',
  4: 'JUE',
  5: 'VIE',
  6: 'SAB'
};
var WeekDaysLong = {
  0: 'Domingo',
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado'
};

var addToDate = function addToDate(base, value, segment) {
  var date = new Date(base);

  switch (segment) {
    case 'DAY':
      date.setDate(base.getDate() + value);
      break;

    case 'HOUR':
      date.setHours(base.getHours() + value);
      break;

    case 'WEEK':
      date.setDate(base.getDate() + value * 7);
      break;

    case 'MONTH':
      date.setMonth(base.getMonth() + value);
      break;

    default:
  }

  return date;
};

var getIntervals = function getIntervals(startDatetime, columnRangeType, columnQuantity) {
  var intervals = new Array(columnQuantity);
  intervals.fill(undefined);
  return intervals.map(function (e, i) {
    return {
      begin: addToDate(startDatetime, i, columnRangeType),
      end: addToDate(startDatetime, i + 1, columnRangeType)
    };
  });
};

var getDateCaption = function getDateCaption(date, range) {
  switch (range) {
    case 'DAY':
      return "".concat(WeekDaysShort[date.getDay()], " ").concat(date.getDate());

    case 'HOUR':
      return "".concat(date.getHours(), ":00");

    case 'WEEK':
      return "Sem ".concat((0, _moment["default"])(date).format('w'), " ").concat((0, _moment["default"])(date).format('MMM DD'));

    case 'MONTH':
      return "".concat((0, _moment["default"])(date).format('MMM'));

    default:
      return '';
  }
};

var getHourDateCaption = function getHourDateCaption(range, intervalIndex, intervals) {
  if (range === 'HOUR') {
    var day = intervals[intervalIndex].begin;

    if (intervals.findIndex(function (i) {
      return i.begin.getDate() === day.getDate();
    }) === intervalIndex) {
      var widthMultiply = intervals.filter(function (i) {
        return i.begin.getDate() === day.getDate();
      }).length;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          whiteSpace: 'nowrap',
          color: 'white',
          width: "".concat(widthMultiply * 100, "%")
        }
      }, "".concat(WeekDaysLong[day.getDay()], " ").concat(day.getDate()), ' ');
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: 'transparent',
        width: '0%'
      }
    }, '.', " ");
  }

  if (range === 'WEEK') {
    var date = intervals[intervalIndex].begin;

    if (intervals.findIndex(function (i) {
      return i.begin.getDate() === date.getDate();
    }) === intervalIndex) {
      var _widthMultiply = intervals.filter(function (i) {
        return i.begin.getDate() === date.getDate();
      }).length;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          whiteSpace: 'nowrap',
          color: 'white',
          width: "".concat(_widthMultiply * 100, "%")
        }
      }, "".concat((0, _moment["default"])(date).format('MMMM'), " ").concat(date.getFullYear()), ' ');
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: 'transparent',
        width: '0%'
      }
    }, '.', " ");
  }

  if (range === 'MONTH') {
    var _date = intervals[intervalIndex].begin;

    if (intervals.findIndex(function (i) {
      return i.begin.getDate() === _date.getDate();
    }) === intervalIndex) {
      var _widthMultiply2 = intervals.filter(function (i) {
        return i.begin.getDate() === _date.getDate();
      }).length;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          whiteSpace: 'nowrap',
          color: 'white',
          width: "".concat(_widthMultiply2 * 100, "%")
        }
      }, "".concat(_date.getFullYear()), ' ');
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        color: 'transparent',
        width: '0%'
      }
    }, '.', " ");
  }
};